module.exports = __webpack_public_path__ + "static/media/29.6f43b3e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/29.png
// module id = 882
// module chunks = 0